angular.module("ainapp")
    .controller("productWiseAgingController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Product Wise Aging";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Init = function () {

                $scope.filter = {
                    Keyword: ""
                }
            }
            $scope.Init();

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        o.data.Keyword = $scope.filter.Keyword;
                        MainService.GetProductWiseAging(o.data).then(function (response) {
                            o.success({
                                Data:response.data
                            });
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) { },
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            ProductCode: {
                                type: "string",
                                editable: false,
                            },
                            ProductName: {
                                type: "string",
                                editable: false,
                            },
                            BalanceQty: {
                                type: "number",
                                editable: false,
                            },
                            AvgRate: {
                                type: "number",
                                editable: false,
                            },
                            BalanceValue: {
                                type: "number",
                                editable: false,
                            },
                            Qty_1_30: {
                                type: "number",
                                editable: false,
                            },
                            Value_1_30: {
                                type: "number",
                                editable: false,
                            },
                            Qty_31_60: {
                                type: "number",
                                editable: false,
                            },
                            Value_31_60: {
                                type: "number",
                                editable: false,
                            },
                            Qty_61_90: {
                                type: "number",
                                editable: false,
                            },
                            Value_61_90: {
                                type: "number",
                                editable: false,
                            },
                            Qty_91_120: {
                                type: "number",
                                editable: false,
                            },
                            Value_91_120: {
                                type: "number",
                                editable: false,
                            },
                            Qty_Over120: {
                                type: "number",
                                editable: false,
                            },
                            Value_Over120: {
                                type: "number",
                                editable: false,
                            },

                        }
                    }
                },
                // serverPaging: true,
                // serverSorting: true,
                // serverFiltering: true,
                pageSize: 20,
                aggregate: [{
                    field: "BalanceQty",
                    aggregate: "sum"
                    }, 
                    {
                    field: "BalanceValue",
                    aggregate: "sum"
                    }, 
                    {
                    field: "Qty_1_30",
                    aggregate: "sum"
                    },
                    {
                    field: "Value_1_30",
                    aggregate: "sum"
                    },
                    {
                    field: "Qty_31_60",
                    aggregate: "sum"
                    },
                    {
                    field: "Value_31_60",
                    aggregate: "sum"
                    },
                     {
                    field: "Qty_61_90",
                    aggregate: "sum"
                    },
                    {
                    field: "Value_61_90",
                    aggregate: "sum"
                    },
                    {
                    field: "Qty_91_120",
                    aggregate: "sum"
                    },
                    {
                    field: "Value_91_120",
                    aggregate: "sum"
                    },
                    {
                    field: "Qty_Over120",
                    aggregate: "sum"
                    },
                    {
                    field: "Value_Over120",
                    aggregate: "sum"
                    }
                
                ],
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 700,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },



                columns: [
                    {
                        field: "ProductCode",
                        title: "Product Code",
                    },
                    {
                        field: "ProductName",
                        title: "Product Name",
                    },
                    {
                        field: "BalanceQty",
                        title: "Balance Qty",
                    },
                    {
                        field: "AvgRate",
                        title: "Avg Rate",
                    },
                    {
                        field: "BalanceValue",
                        title: "Balance Value",
                        template: "<div style='text-align: right'>#=kendo.toString(BalanceValue, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Balance Value</div>")
                    },
                    {
                        field: "Qty_1_30",
                        title: "1-30",
                        template: "<div style='text-align: right'>#=kendo.toString(Qty_1_30, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>1-30</div>")
                    },
                    {
                        field: "Value_1_30",
                        title: "Value",
                        template: "<div style='text-align: right'>#=kendo.toString(Value_1_30, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Value</div>")
                    },
                    {
                        field: "Qty_31_60",
                        title: "31-60",
                        template: "<div style='text-align: right'>#=kendo.toString(Qty_31_60, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>31-60</div>")
                    },
                    {
                        field: "Value_31_60",
                        title: "Value",
                        template: "<div style='text-align: right'>#=kendo.toString(Value_31_60, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Value</div>")
                    },
                    {
                        field: "Qty_61_90",
                        title: "61-90",
                        template: "<div style='text-align: right'>#=kendo.toString(Qty_61_90, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>61-90</div>")
                    },
                    {
                        field: "Value_61_90",
                        title: "Value",
                        template: "<div style='text-align: right'>#=kendo.toString(Value_61_90, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Value</div>")
                    },
                    {
                        field: "Qty_91_120",
                        title: "91-120",
                        template: "<div style='text-align: right'>#=kendo.toString(Qty_91_120, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>91-120</div>")
                    },
                    {
                        field: "Value_91_120",
                        title: "Value",
                        template: "<div style='text-align: right'>#=kendo.toString(Value_91_120, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Value</div>")
                    },
                    {
                        field: "Qty_Over120",
                        title: "> 120",
                        template: "<div style='text-align: right'>#=kendo.toString(Qty_Over120, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'> > 120</div>")
                    },
                    {
                        field: "Value_Over120",
                        title: "Value",
                        template: "<div style='text-align: right'>#=kendo.toString(Value_Over120, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Value</div>")
                    },

                ],
            };


            $scope.SearchKendo = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.refresh = function () {
                $scope.Init();
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.Recalculate = function (id) {
                MainService.RecalculateProductStockBalance(id).then(function (response) {
                    if (response.data) {
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                    } else {
                        toastr.error("Network Error");
                    }
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                })
            }


        }])
